var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CieloLayout',[(!_vm.loading)?_c('router-view'):_vm._e(),(_vm.loading)?_c('div',{staticClass:"row"},[_c('MoonLoader',{staticClass:"loader mx-auto mt-5 mb-4",attrs:{"color":"#00AEEF","size":"70px"}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }